module.exports = __webpack_public_path__ + "h5assets/img/new-collabs-level-company-tw@2x.ad5386f.png";